/**
 * Lista nawigowalnych stron
 */

export enum NavigationPages {
    beginningPage,
    offerSearchPage,
    roomStandardSearchPage,
    shopPage,
    confirmationPage,
    paymentOnlinePage,
    traditionalTransferPage,
    paymentLaterPage,
    paymentOnSitePage,
    packetSearchPage,
    basketPage,
}
export type NavigationPageName = 'standards' | 'offers' | 'shop' | 'confirmation' | 'paymentOnlinePage'
    | 'traditionalTransferPage' | 'paymentLaterPage' | 'paymentOnSitePage' | 'packetSearchPage' | 'basket';

/**
 * Na podstawie nazwy używanej na frontendzie, zwraca stronę
 * @param page
 */
export function getNavigationPageFromName(page: NavigationPageName): NavigationPages|null {
    switch(page) {
        case 'standards':
            return NavigationPages.roomStandardSearchPage;
        case 'offers':
            return NavigationPages.offerSearchPage;
        case 'basket':
            return NavigationPages.basketPage;
        case 'shop':
            return NavigationPages.shopPage;
        case 'confirmation':
            return NavigationPages.confirmationPage;
        case 'paymentOnlinePage':
            return NavigationPages.paymentOnlinePage;
        case 'traditionalTransferPage':
            return NavigationPages.traditionalTransferPage;
        case 'paymentLaterPage':
            return NavigationPages.paymentLaterPage;
        case 'paymentOnSitePage':
            return NavigationPages.paymentOnSitePage;
        case 'packetSearchPage':
            return NavigationPages.packetSearchPage;
    }
    return null;

}

/**
 * Na podstawie strony, zwraca nazwę używaną na frontendzie
 * @param page
 */
export function getNavigationNameFromPage(page: NavigationPages): NavigationPageName {

    switch(page) {
        case NavigationPages.roomStandardSearchPage:
            return 'standards';
        case NavigationPages.offerSearchPage:
            return 'offers';
        case NavigationPages.shopPage:
            return 'shop';
        case NavigationPages.confirmationPage:
            return 'confirmation';
        case NavigationPages.paymentOnlinePage:
            return 'paymentOnlinePage';
        case NavigationPages.traditionalTransferPage:
            return 'traditionalTransferPage';
        case NavigationPages.paymentLaterPage:
            return 'paymentLaterPage';
        case NavigationPages.paymentOnSitePage:
            return 'paymentOnSitePage';
        case NavigationPages.packetSearchPage:
            return 'packetSearchPage';
        case NavigationPages.basketPage:
            return 'basket';
        default:
            throw Error('Unsupported page type '+page);
    }
}
